export const API_BASE_URL = "https://api.fastmate.app/aiut251";
export const WEB_FUNNEL_URL = "https://pre.fastmate.app";
export const ANDROID_URL =
  "https://play.google.com/store/apps/details?id=app.fastmate.ai";
export const IOS_URL =
  "https://apps.apple.com/in/app/fastmate-fasting-meal-ai/id6746123500";

export const FREE_EMAILS_LIST = API_BASE_URL + "";
export const GET_GENERAL_PAGES = API_BASE_URL + "/pre/general/pages";
